import { Form, Input, Select, Switch } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';

//布局
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const { TextArea } = Input;

export default function MenuMovieEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /** 菜品智库数据 */
    const [menuWarehouseData, setMenuWarehouseData] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = "";

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }
        const fetchData = async () => {

            form.setFieldsValue({ menuWarehouseId: data.sendPageData.menuWarehouseId });

            fetchApi.GET(wmService, {
                apiId: 'menuWarehouse',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMenuWarehouseData(res.data);
                }
            });
        }
        fetchData()
    }, [])

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'menuMovie'
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '菜式视频'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
            >
                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Form.Item
                        label="id"
                        name="id">
                        <Input disabled={true} />
                    </Form.Item>

                    <Form.Item
                        label="菜式名称"
                        name="menuWarehouseId"
                        rules={[{ required: true, message: '请填写菜式!' }]}>
                        <Select
                            disabled
                            showSearch
                            placeholder="菜式名称"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(menuWarehouseData, 'foodName')}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="标题"
                        name="title"
                        rules={[{ required: true, message: '请输入标题!' }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="视频ID"
                        name="movieId"
                        rules={[{ required: true, message: '请输入视频ID!' }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="简介"
                        name="introduction">
                        <TextArea
                            placeholder="简介"
                            autoSize={{ minRows: 2, maxRows: 5 }}
                            showCount
                            maxLength={250}
                            styles={{
                                // 直接调整计数器的样式，增加底部外边距
                                count: { marginBottom: 24, marginRight: 20 }
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="备注"
                        name="memo">
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="隐私查看"
                        name="isPrivacy"
                        valuePropName="checked"
                        initialValue={false}>
                        <Switch checked={false}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>

                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        <Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>

                </Form>
            </AntDraggableModal>
        </>
    )
}